export const EU_COUNTRY_CODES = [
  'be',
  'bg',
  'cz',
  'dk',
  'de',
  'ee',
  'ie',
  'el',
  'es',
  'fr',
  'hr',
  'it',
  'cy',
  'lv',
  'lt',
  'lu',
  'hu',
  'mt',
  'nl',
  'at',
  'pl',
  'pt',
  'ro',
  'si',
  'sk',
  'fi',
  'se',
];
